import { render, staticRenderFns } from "./recommendedDetails.vue?vue&type=template&id=29277274&scoped=true"
import script from "./recommendedDetails.vue?vue&type=script&lang=js"
export * from "./recommendedDetails.vue?vue&type=script&lang=js"
import style0 from "./recommendedDetails.vue?vue&type=style&index=0&id=29277274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29277274",
  null
  
)

export default component.exports